import { render, staticRenderFns } from "./CustomerCover.vue?vue&type=template&id=3549cd69&scoped=true"
import script from "./CustomerCover.vue?vue&type=script&lang=js"
export * from "./CustomerCover.vue?vue&type=script&lang=js"
import style0 from "./CustomerCover.vue?vue&type=style&index=0&id=3549cd69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3549cd69",
  null
  
)

export default component.exports